var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header'),_c('div',{staticStyle:{"display":"flex","background-color":"#012430","padding-top":"10px","justify-content":"space-between","min-width":"1758px"}},[_c('div',{staticClass:"menu"},[_c('Menu',{attrs:{"supplierinfo":_vm.supplierinfo}})],1),_c('div',{staticClass:"content"},[_c('Content')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }